import { useSelector } from "react-redux"
import { trimLowerCase } from "../helpers/shared"
import { envSetting } from "../constants/envSetting"
import { isLendecyApp } from "../helpers/base"

export const useConditionallyFinish = () => {
    const { 
      data: { 
        product_request: { 
              user: userInfo 
          }  = {}
        } = {} 
      } = useSelector(state => state.personData || {})
    const { level, appOrigin } = useSelector(state => state.user)
    const { lastTier } = useSelector(state => state.tier)
    let conditionalStates = envSetting?.conditionalStates.split(',')

    const isLendecy = isLendecyApp()
    let isConditionallyFinished = conditionalStates.includes(trimLowerCase(userInfo?.state)) && isLendecy
                            && (parseInt(level) >= (parseInt(lastTier?.verification_level)-1))

    return {
        isConditionallyFinished
    }
}